import { createTheme } from '@mui/material/styles';

const getTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: { main: '#6366f1' },
      secondary: { main: '#22c55e' },
      success: { main: '#22c55e' },
      warning: { main: '#f59e0b' },
      error: { main: '#ef4444' },
      info: { main: '#06b6d4' },
      ...(mode === 'dark'
        ? {
            background: { default: '#0e0f11', paper: '#1a1b1f' },
            text: { primary: '#f3f4f6', secondary: '#9ca3af' },
            divider: 'rgba(255,255,255,0.08)',
          }
        : {
            background: { default: '#f5f6fa', paper: '#ffffff' },
          }),
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: 'Roboto, Arial, sans-serif',
    },
  });

export default getTheme;
